module.exports = __webpack_public_path__ + "img/tiktok.33befd40.png";